// packages block
import React from "react";
import moment from "moment";
// common block
import { useStyles } from "../../../../components/managementTable/styles";
// constants, theme, utils and api block
import { BLUE_TWELVE, WHITE } from "../../../../theme";
import { STUDENT_DETAIL_TABS } from "../../../../util/constants";
import { formatEmptyToNA } from "../../../../util/stringManipulation";

export const DetailTabs = ({ student }) => {
  const [tab, setTab] = React.useState(0);
  const classes = useStyles();
  return (
    <div>
      <div
        className={classes.thead}
        style={{
          display: "flex",
          padding: "10px 0px",
          justifyContent: "space-around",
        }}
      >
        {STUDENT_DETAIL_TABS.map(({ id, value }) => {
          return (
            <div
              key={id}
              role="presentation"
              onClick={() => {
                setTab(id);
              }}
              style={{
                padding: "5px 10px",
                fontWeight: "bold",
                cursor: "pointer",
                color: id === tab ? WHITE : BLUE_TWELVE,
                fontSize: "0.85vw",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              {value}
            </div>
          );
        })}
      </div>

      <div style={{ padding: "10px 20px" }}>
        {tab === 0 && (
          <div>
            <DetailItem
              label={"First Name"}
              style={{ textTransform: "capitalize" }}
              value={student?.firstName ?? "N/A"}
            />

            <DetailItem
              label={"Last Name"}
              value={student?.lastName ?? "N/A"}
            />

            <DetailItem
              label={"Date of Birth"}
              value={
                student?.dob ? moment(student?.dob).format("DD-MM-YYYY") : "N/A"
              }
            />

            <DetailItem label={"Gender"} value={student?.gender ?? "N/A"} />

            <DetailItem
              label={"Emirates ID Number"}
              value={formatEmptyToNA(student?.emiratesId)}
            />

            <DetailItem
              label={"Phone Number"}
              value={formatEmptyToNA(student?.parentPhoneNumber)}
            />

            <DetailItem
              label={"Nationality"}
              value={formatEmptyToNA(student?.StudentCountry?.nicename)}
            />

            <DetailItem
              label={"Religion"}
              value={formatEmptyToNA(student?.religion)}
            />
          </div>
        )}
        {tab === 1 && (
          <div>
            <DetailItem
              label={"First Name"}
              value={formatEmptyToNA(student?.parentFirstName)}
            />
            <DetailItem
              label={"Last Name"}
              value={formatEmptyToNA(student?.parentLastName)}
            />
            <DetailItem
              label={"Gender"}
              value={formatEmptyToNA(student?.parentGender)}
            />
            <DetailItem
              label={"Emirates ID Number"}
              value={formatEmptyToNA(student?.parentEmiratesId)}
            />

            <DetailItem
              label={"Nationality"}
              value={formatEmptyToNA(student?.ParentCountry?.nicename)}
            />

            <DetailItem
              label={"Religion"}
              value={formatEmptyToNA(student?.parentReligion)}
            />
          </div>
        )}

        {tab === 2 && (
          <div>
            <DetailItem
              label={"Email"}
              value={formatEmptyToNA(student?.email)}
            />
            {/* <DetailItem label={"Phone Number"} value={student.phoneNumber} /> */}
            <DetailItem
              label={"Parent Phone Number"}
              value={formatEmptyToNA(student?.phoneNumber)}
            />

            <DetailItem
              label={"Other Phone Number"}
              value={formatEmptyToNA(student?.otherNumber)}
            />

            <DetailItem
              label={"Payee Type"}
              value={formatEmptyToNA(student?.payeeType)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const DetailItem = ({ label, value }) => {
  return (
    <div style={{ padding: "7px 0px" }}>
      <div style={{ color: "gray", fontSize: 12, textTransform: "capitalize" }}>
        {label}
      </div>
      <div style={{ fontSize: 13, fontWeight: "700" }}>{value}</div>
    </div>
  );
};
